'use strict';

import { hostFactory as hostInstance } from "@api/factory";

import { LoggerBus } from '@app/utils/logger-bus';
import EventBus from '@app/utils/event-bus';
const loggerFormat = '[api::users::events]';

const eventIndex = (companyId, userId) =>{
  LoggerBus.$log.debug(loggerFormat);
  const baseUrl = getUrl(companyId, userId);
  return hostInstance.get(baseUrl);
}

const eventStore = (companyId, userId, event, headers = {}) => {
  LoggerBus.$log.debug(loggerFormat);
  const baseUrl = getUrl(companyId, userId);
  return hostInstance.post(baseUrl, event, headers);
}

const eventShow = (companyId, userId, eventId)  =>{
  LoggerBus.$log.debug(loggerFormat);
  const baseUrl = getUrl(companyId, userId);
  return hostInstance.get(`${baseUrl}/${eventId}`);
}

const eventUpdate = (companyId, userId, eventId, event, headers={}) =>{
  LoggerBus.$log.debug(loggerFormat);
  const baseUrl = getUrl(companyId, userId);
  return hostInstance.post(`${baseUrl}/${eventId}`, event, headers);
}

const eventActivate = (companyId, userId, eventId) =>{
  LoggerBus.$log.debug(loggerFormat);
  const baseUrl = getUrl(companyId, userId);
  return hostInstance.patch(`${baseUrl}/${eventId}/enable`);
}

const eventDeactivate = (companyId, userId, eventId) =>{
  LoggerBus.$log.debug(loggerFormat);
  const baseUrl = getUrl(companyId, userId);
  return hostInstance.patch(`${baseUrl}/${eventId}/disable`);
}

const eventDestroy = (companyId, userId, eventId) =>{
  LoggerBus.$log.debug(loggerFormat);
  const baseUrl = getUrl(companyId, userId);
  return hostInstance.delete(`${baseUrl}/${eventId}`);
}

const eventDestroyFile = (companyId, userId, eventId, fileId) =>{
  LoggerBus.$log.debug(loggerFormat);
  const baseUrl = getUrl(companyId, userId);
  return hostInstance.delete(`${baseUrl}/${eventId}/files/${fileId}`);
}

const eventDownloadFile = async (companyId, userId, eventId, fileId) =>{
  LoggerBus.$log.debug(loggerFormat);
  const baseUrl = getUrl(companyId, userId);
  
  let progress = 0;
  const opts = {
    responseType: 'arraybuffer',
    onDownloadProgress: (progressEvent) => {
      progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
      EventBus.DownloadProgressBar.$emit('onDownloadProgress', {progress: progress});
    }
  };

  return await hostInstance.get(`${baseUrl}/${eventId}/files/${fileId}/download`, opts);
}

const getUrl = (companyId, userId) => {
  return `/api/companies/${companyId}/users/${userId}/events`
}

export default {
  eventIndex,
  eventStore,
  eventShow,
  eventUpdate,
  eventActivate,
  eventDeactivate,
  eventDestroy,
  eventDestroyFile,
  eventDownloadFile
};